var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmTemplateSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-115 -51)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    rx: 3,
    transform: "translate(115 51)",
    fill: "#ffbfbf"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(120.225 57.307)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.1,6h8.8A1.1,1.1,0,0,1,14,7.1v6.6a1.1,1.1,0,0,1-1.1,1.1H4.1A1.1,1.1,0,0,1,3,13.7V7.1A1.1,1.1,0,0,1,4.1,6Z",
    transform: "translate(-3 -6)",
    fill: "none",
    stroke: "#d60000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14,9,8.5,12.768,3,9",
    transform: "translate(-3 -7.923)",
    fill: "none",
    stroke: "#d60000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmTemplateSmall);
export default __webpack_public_path__ + "static/media/em_template_small.0c32d7109c6941ed34b1a1f4d9f5c1d9.svg";
export { ForwardRef as ReactComponent };